<template>
  <div class="d-flex justify-start align-center" :class="[oneLined == 1 ? 'flex-row' : 'flex-column']">
    <!-- Tarif de base, possiblement majoré -->

    <div class="text-h6 mt-3 text-center" v-if="course_solo">
      <b>{{ get_default_tarif_on_home }}</b> <span style="font-size: 9px; position: relative; top: -1px">
        <span v-if="mainStore.module.metadatas?.exclure_taxe != '1' && get_default_tarif_on_home != 'Gratuit'">(+ frais
          gestion)</span></span>
    </div>
    <div class="d-flex text-h6 text-center"
      :class="[oneLined == 1 ? 'flex-row sm-gap align-items-center mt-1' : 'flex-column mt-3 ']" v-else>

      <b v-if="!withoutPerPerson">{{ get_default_tarif_on_home }}/pers</b>

      <span style="font-size: 12px">{{ total_tarif_equipe }}€ {{ mainStore.module.metadatas?.exclure_taxe != '1' ?
        '(+ frais gestion)' : '' }}</span>
    </div>

    <!-- Modal du détail des tarifs, si il y a des majorations ou plusieurs tarifs -->
    <v-dialog v-if="tarifs.has_upcoming_majorations() || tarifs.list.length > 1" v-model="showDialog" width="500"
      max-width="100%" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <v-btn color="darkblue" variant="text" size="small" v-bind="props" class="no-uppercase"><v-icon
            icon="mdi-information-outline" class="mr-1" size="large"></v-icon> Détails tarif </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <TarifItem class="tarif_course_item mb-2 bg-grey_1 px-2 py-1 rounded bordered" v-for="tarif in tarifs.list"
            :key="tarif.id" :tarif="tarif"></TarifItem>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="showDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import TarifItem from "@/components/Home/Courses/Tarif_Item.vue";
export default {
  props: ["tarifs", "course", "all_courses", "oneLined", "withoutPerPerson"],
  components: { TarifItem },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    get_default_tarif_on_home() {
      const all_courses = this.mainStore.module.courses.list;
      let prix = this.tarifs.get_default_tarif_on_home(all_courses);
      if (prix == 0) {
        return "Gratuit";
      }
      return prix + "€";
    },
    course_solo() {
      return this.course.is_solo();
    },
    total_tarif_equipe() {
      let equipe_size = this.course.get_equipe_size();
      const all_courses = this.mainStore.module.courses.list;
      let total = this.tarifs.get_default_tarif_on_home(all_courses) * equipe_size;
      return total;
    },
  },
};
</script>

<style lang="scss" scoped></style>